const TopicLabel = ({ topic }) => {
  const { contentType, publicLabel } = topic

  if (!contentType === 'article' || !publicLabel) {
    return null
  }

  return (
    <span class={'thread__content-type-pill pill pill--uppercase pill--article qa-content-type-pill'}>
      { publicLabel }
    </span>
  )
}

export default TopicLabel
